import React from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import * as LoginFailedStyles from "../styles/loginFailed";

function LoginFailed() {
    const navigate = useNavigate();

    function goToHome() {
        navigate("/");
    }

    return (
        <div style={LoginFailedStyles.body}>
            <h2>Sorry, but we have failed to log you in</h2>
            <br />
            <Button onClick={goToHome}>Go To Home</Button>
        </div>
    );
}

export default LoginFailed;
